import { createContext, useContext, useEffect, type ReactNode } from "react";
import { useWalletSetupFlow } from "@/hooks/wallet/useWalletSetupFlow";
import { resetWalletSetupLock } from "@/lib/wallet/walletSetupLock";

type WalletSetupContextValue = ReturnType<typeof useWalletSetupFlow>;

const WalletSetupContext = createContext<WalletSetupContextValue | null>(null);

export function WalletSetupProvider({ children }: { children: ReactNode }) {
  const value = useWalletSetupFlow();

  useEffect(() => {
    return () => {
      resetWalletSetupLock();
    };
  }, []);

  return (
    <WalletSetupContext.Provider value={value}>
      {children}
    </WalletSetupContext.Provider>
  );
}

export function useWalletSetupOptional(): WalletSetupContextValue | null {
  return useContext(WalletSetupContext);
}

export function useWalletSetup(): WalletSetupContextValue {
  const context = useWalletSetupOptional();
  if (!context) {
    throw new Error("useWalletSetup must be used within WalletSetupProvider");
  }
  return context;
}
